import styled, { css } from 'styled-components'
import Button from './Button'

export interface TabButtonProps {
	active: boolean
}
const TabButton = styled(Button)<TabButtonProps>`
	margin-right: 20px;
	border: 2px solid #6366f1;
	border-radius: 25px;
	transition: all 0.3s ease;
	${(props) => {
		if (props.active) {
			return css`
				background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
				color: white;
				border-color: #6366f1;
				box-shadow: 0px 4px 15px rgba(99, 102, 241, 0.3);
				&:hover {
					background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
					transform: translateY(-1px);
					box-shadow: 0px 6px 20px rgba(99, 102, 241, 0.4);
				}
			`
		} else {
			return css`
				color: #6366f1;
				background: rgba(99, 102, 241, 0.1);
				border-color: #6366f1;
				&:hover {
					background: rgba(99, 102, 241, 0.2);
					transform: translateY(-1px);
				}
			`
		}
	}}
	@media (max-width: 700px) {
		height: 42px;
		padding: 0 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px;
		border-radius: 20px;
		font-size: 13px;
	}

	@media (max-width: 400px) {
		padding: 0 2px;
	}
`

export default TabButton
